import ImgixImg from '../../elements/imgix-img'
import Category from '../../compounds/category'
import Breadcrumb from '../../compounds/breadcrumb'
import { useEntity } from '@uswitch/ev-utils/context/selectors'

const Figure = props => {
  const Breadcrumbs = props.breadcrumbs && <Breadcrumb entity={props.breadcrumbs} />
  const Image = (
    <If condition={props.image?.sys}>
      <ImgixImg
        {...props}
        src={props.image?.file?.url}
        alt={props.image?.title}
        sx={{
          maxHeight: '180px',
          display: 'block',
          marginLeft: 'auto',
          marginRight: ['auto', 0],
        }}
      />
    </If>
  )

  return <Category {...props} breadcrumbs={Breadcrumbs} image={Image} />
}

const FigureConnected = props => {
  const imageEntity = useEntity(props.image)
  return <Figure {...props} image={imageEntity} />
}

export default FigureConnected
